// extracted by mini-css-extract-plugin
export default {"kebab":"RowKebabMenu_kebab__IE9qB","kebabIcon":"RowKebabMenu_kebabIcon__xoTCx","slot":"RowKebabMenu_slot__Awz6I"};